import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import "./ShortAnswer.css";

interface ShortAnswerProps {
    optionalContext: string
    text: string
}

const ShortAnswer = observer(({optionalContext, text}: ShortAnswerProps) => {
    return (
        <div>
              <div className="question-type-header">Short Answer</div>
              {optionalContext && optionalContext.length > 0 ? <div className="optional-context">{optionalContext}</div> : <span></span>}
              <div className="question-text">{text}</div>
        </div>
      );
});

export default ShortAnswer;
